SET_PAYMENT_AUTHORIZATION